<template>
  <div class="featured relative flex">
    <div class="information" :class="categorySlug">
      <div class="top-spacing"></div>
      <div class="featured-banner" :class="categorySlug">
        <div class="col-1 ml-3"></div>
        <div class="featured-star"></div>
        <div class="body-11 text-white ml-auto mr-auto">FEATURED</div>
      </div>
      <div class="flex">
        <div class="col-1 ml-3"></div>
        <div class="featured-name">
          <div class="first-name flex">
            <h5>{{ article.first_name }}</h5>
          </div>
          <h2>{{ article.last_name }}</h2>
        </div>
      </div>
      <hr>
      <div class="flex">
        <div class="col-1 ml-3"></div>
          <router-link :to="articleLink" class="bg-white text-grey-2 rounded-full body-13">Click to view article</router-link>
      </div>
    </div>
    <div class="featured-image" :style="{backgroundImage: `url(${article.featured_image_url})`}"></div>
    <img :alt="articleImgAlt" :src="`${article.featured_image_url}`" class="hidden"/>
  </div>
</template>

<script>
  import { isDefined } from '@/common/utils/utils';

  export default {
    name: 'LernerFeatured',
    props: ['article'],

    data() {
      return {
        ADMIN_API_HOST: process.env.VUE_APP_ADMIN_HOST,
      }
    },

    computed: {
      articleLink: function () {
        return {
          name: 'article',
          params: {
            article: this.article.slug,
            category: this.categorySlug
          }
        }
      },
      articleImgAlt: function () {
        return `${this.article.first_name} ${this.article.last_name}`
      },
      categorySlug: function() {
        if (isDefined(this.article.categories) && this.article.categories.length) {
          return this.article.categories[0].slug;
        }

        return 'default';
      }
    }
  }
</script>

<style lang="scss" scoped>
  .featured {
    height: 520px;

    .featured-banner {
      width: 270px;
      height: 50px;
      border-radius: 0 50px 50px 0;
      @apply flex items-center;

      .featured-star {
        width: 73px;
        height: 70px;
      }

      &.basketball {
        @apply bg-c1-b;

        .featured-star {
          background: no-repeat url("../assets/images/28-lrn-spt-feat-main-bar-cat-1.svg");
        }
      }

      &.football {
        @apply bg-c2-b;

        .featured-star {
          background: no-repeat url("../assets/images/29-lrn-spt-feat-main-bar-cat-2.svg");
        }
      }

      &.baseball {
        @apply bg-c3-b;

        .featured-star {
          background: no-repeat url("../assets/images/30-lrn-spt-feat-main-bar-cat-3.svg");
        }
      }

      &.soccer {
        @apply bg-c4-b;

        .featured-star {
          background: no-repeat url("../assets/images/31-lrn-spt-feat-main-bar-cat-4.svg");
        }
      }

      &.more-sports {
        @apply bg-c5-b;

        .featured-star {
          background: no-repeat url("../assets/images/32-lrn-spt-feat-main-bar-cat-5.svg") center;
        }
      }

      &.olympics {
        @apply bg-c6-b;

        .featured-star {
          background: no-repeat url("../assets/images/olympics-category-featured-star.svg") center;
        }
      }

      &.hockey {
        @apply bg-c7-b;

        .featured-star {
          background: no-repeat url("../assets/images/hockey-category-featured-star.svg") center;
        }
      }

      &.tennis {
        @apply bg-c8-b;

        .featured-star {
          background: no-repeat url("../assets/images/tennis-category-featured-star.svg") center;
        }
      }
    }

    .information {
      height: 520px;
      @apply absolute pin-t pin-l z-10;
      width: 50%;
      background-position-x: right;
      background-repeat: no-repeat;

      @media (min-width: config('screens.xl')) {
        width: 60%;
        background-position-x: left;
      }

      &.basketball {
        background-image: url("../assets/images/23-lrn-spt-feat-main-bkgd-cat-1.svg");
      }

      &.football {
        background-image: url("../assets/images/24-lrn-spt-feat-main-bkgd-cat-2.svg");
      }

      &.baseball {
        background-image: url("../assets/images/25-lrn-spt-feat-main-bkgd-cat-3.svg");
      }

      &.soccer {
        background-image: url("../assets/images/26-lrn-spt-feat-main-bkgd-cat-4.svg");
      }

      &.more-sports {
        background-image: url("../assets/images/more-sports-category-featured.svg");
      }

      &.olympics {
        background-image: url("../assets/images/olympics-category-featured.svg");
      }

      &.hockey {
        background-image: url("../assets/images/hockey-category-featured.svg");
      }

      &.tennis {
        background-image: url("../assets/images/tennis-category-featured.svg");
      }
    }

    .featured-name {
      .first-name {
        height: 80px;

        h5 {
          margin-top: auto;
          @apply text-white mb-0 leading-none;
        }
      }

      h2 {
        @apply text-white uppercase leading-none;
      }
    }

    .featured-image {
      position: absolute;
      top: 0;
      right: 0;
      width: 60%;
      height: 520px;
      background-size: cover;
      background-position: center;
    }
  }


  .top-spacing {
    height: 80px;
  }

  a {
    padding: 6px 15px;
  }

  hr {
    width: 80%;
    height: 2px;
    @apply mb-9 ml-0 bg-white;
  }
</style>
